import React, { useMemo, useState, useEffect } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import { useSubscription } from "@apollo/client";
import objectPath from "object-path";

import { useCurrentUserUIContext } from "../../../../app/Components/CurrentUser/CurrentUserContext";
import { usePermissionRoleUIContext } from "../../../../app/Components/PermissionRole";
import { RELOAD_NOTIFICATION } from "../../../../app/GraphQlCommon/mutation";
import * as auth from "../../../../app/Modules/Auth/_redux/authRedux";
import { ROLE_GUEST } from "../../../../app/Utils/constant";
import { toAbsoluteUrl } from "../../../_helpers";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import { LanguageSelectorDropdown } from "../extras/dropdowns/LanguageSelectorDropdown";
import { MyCartDropdown } from "../extras/dropdowns/MyCartDropdown";
import { QuickActionsDropdown } from "../extras/dropdowns/QuickActionsDropdown";
import { QuickUserToggler } from "../extras/QuiclUserToggler";

export function Topbar() {
  const dispatch = useDispatch();

  let history = useHistory();
  const uiService = useHtmlClassService();

  const [userDetail, setUserDetail] = useState(null);

  const [
    anchorElChangeOrganisation,
    setAnchorElChangeOrganisation
  ] = React.useState(null);

  const openOrganisationList = Boolean(anchorElChangeOrganisation);

  const idOrganisationList = openOrganisationList ? "simple-popper" : undefined;

  const [isOrgActionClick, setIsOrgActionClick] = useState(false);

  const { setPermissionRoles } = usePermissionRoleUIContext();

  const layoutProps = useMemo(() => {
    return {
      viewSearchDisplay: objectPath.get(
        uiService.config,
        "extras.search.display"
      ),
      viewNotificationsDisplay: objectPath.get(
        uiService.config,
        "extras.notifications.display"
      ),
      viewUserDisplay: objectPath.get(uiService.config, "extras.user.display")
    };
  }, [uiService]);

  const currentUserContext = useCurrentUserUIContext();

  const currentUserUIProps = useMemo(() => {
    return {
      currentUser: currentUserContext.currentUser,
      setCurrentUser: currentUserContext.setCurrentUser,
      currentUserError: currentUserContext.currentUserError
    };
  }, [currentUserContext]);

  useSubscription(RELOAD_NOTIFICATION, {
    variables: {
      userId: userDetail?.id
    },
    fetchPolicy: "no-cache",
    onSubscriptionData(d) {
      currentUserUIProps.setCurrentUser();
    }
  });
  useEffect(() => {
    if (currentUserUIProps.currentUser) {
      const data = currentUserUIProps.currentUser?.me;

      setUserDetail(data);
      setUserData(data);
    }
  }, [currentUserUIProps]);
  const setUserData = currentUser => {
    if (currentUser) {
      const data = currentUser;

      if (data.userOrg) {
        var tempObj = data.userOrg.find(element => {
          if (element.organization?.id === data.currentOrganization?.id) {
            if (
              element.roles &&
              element.roles[0]?.key === ROLE_GUEST &&
              element.isIndividual
            )
              return null;
            else return element;
          }
        });
        if (tempObj) {
          const user = JSON.parse(window.localStorage.getItem("user"));

          if (user) {
            user.isUserVerified = tempObj.isVerified;
            user.isIndividual = tempObj.isIndividual;
            user.isInvited = tempObj.isInvited;
            user.isInvitedAndMerge = tempObj.isInvitedAndMerge;
            user.currentOrganization = data.currentOrganization;
            user.userOrg = data.userOrg;
            user.title = data.title;
            user.mobile = data.mobile;
            user.whatsAppUsername = data.whatsAppUsername;
            user.skypeUsername = data.skypeUsername;
            user.fax = data.fax;
            user.isEmailVarified = data.isEmailVarified;
            if (tempObj?.roles && tempObj?.roles.length > 0) {
              user.roles = tempObj?.roles;
            } else user.roles = data?.roles;
            window.localStorage.setItem("user", JSON.stringify(user));
            dispatch(
              auth.actions.fulfillUser({
                ...user
              })
            );
          }

          const roles = tempObj?.roles.map(role => role.key);

          if (roles && roles.length > 0) {
            window.localStorage.setItem("roles", JSON.stringify(roles));
          } else {
            const roles = data?.roles.map(role => role.key);

            window.localStorage.setItem("roles", JSON.stringify(roles));
          }

          setPermissionRoles();
        } else if (
          data?.roles?.findIndex(val => val?.key === ROLE_GUEST) > -1 &&
          data.isUserVerified
        ) {
          let tempData = { ...data };
          tempData.isIndividual = true;
          window.localStorage.setItem("user", JSON.stringify(tempData));
          dispatch(
            auth.actions.fulfillUser({
              ...tempData
            })
          );
          const role = tempData?.roles.map(role => role.key);

          window.localStorage.setItem("roles", JSON.stringify(role));
        }
      } else {
        window.localStorage.setItem("user", JSON.stringify(data));
        dispatch(
          auth.actions.fulfillUser({
            ...data
          })
        );
        const role = data?.roles.map(role => role.key);

        window.localStorage.setItem("roles", JSON.stringify(role));
      }
    }
  };

  return (
    <>
      <div className="topbar">
        {layoutProps.viewQuickActionsDisplay && <QuickActionsDropdown />}

        {layoutProps.viewCartDisplay && <MyCartDropdown />}

        {layoutProps.viewQuickPanelDisplay && (
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="quick-panel-tooltip">Quick panel</Tooltip>}
          >
            <div
              className="topbar-item"
              data-toggle="tooltip"
              title="Quick panel"
              data-placement="right"
            >
              <div
                className="btn btn-icon btn-clean btn-lg mr-1"
                id="kt_quick_panel_toggle"
              >
                <span className="svg-icon svg-icon-xl svg-icon-primary">
                  <SVG
                    src={toAbsoluteUrl(
                      "/media/svg/icons/Layout/Layout-4-blocks.svg"
                    )}
                  />
                </span>
              </div>
            </div>
          </OverlayTrigger>
        )}

        {layoutProps.viewLanguagesDisplay && <LanguageSelectorDropdown />}

        {layoutProps.viewUserDisplay && <QuickUserToggler />}
      </div>
    </>
  );
}
